module.exports = __webpack_public_path__ + "img/piyao-suject-icon-right.040c4d35.png";